import React from "react";
import { FiPlus, FiCheckCircle, FiArrowRight } from "react-icons/fi";
import { motion } from "framer-motion";

const TravelTipsSection = () => {
  return (
    <section className="bg-[#E7F3FF] py-18 px-6 lg:px-10">
      <div className="flex flex-col lg:flex-row items-center gap-20">

        {/* LEFT IMAGE BLOCK */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="relative w-full lg:w-[60%]"
        >
          <div className="rounded-3xl overflow-hidden shadow-xl border-[6px] border-blue-400">
            <img
              src="https://images.pexels.com/photos/3935702/pexels-photo-3935702.jpeg"
              alt="Travel Tips"
              className="w-full md:h-[70vh] h-[40vh] object-cover"
            />
          </div>

          {/* Circular Badge */}
          <motion.div
            initial={{ scale: 0 }}
            whileInView={{ scale: 1 }}
            transition={{ duration: 0.6 }}
            className="absolute -bottom-10 left-1/2 -translate-x-1/2 lg:left-auto lg:-right-10 
            bg-gradient-to-br from-blue-500 to-blue-700 text-white w-48 h-48 
            rounded-full flex flex-col justify-center items-center shadow-2xl"
          >
            <div className="text-4xl font-black tracking-wide">24k+</div>
            <div className="text-sm opacity-90 mt-1">Successful Projects</div>
          </motion.div>
        </motion.div>

        {/* RIGHT TEXT BLOCK */}
        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="w-full lg:w-[55%]"
        >
          <h2 className="text-4xl lg:text-5xl font-extrabold text-blue-500 leading-tight">
            Turn Your Travel <br /> <span className="text-blue-600">Dream Into Reality</span>
          </h2>

          <p className="text-gray-600 mt-4 text-lg leading-relaxed">
            Let our expert guidance help you transform your vision into unforgettable journeys.
            From planning to execution, we ensure a smooth, stress-free, and extraordinary travel experience.
          </p>

          {/* Interactive Highlighted List */}
          <div className="mt-6 space-y-3">
            {[
              "Personalized travel planning with expert consultants",
              "24/7 support for hassle-free assistance",
              "Visa guidance, document checklists & fast processing",
              "Exclusive travel tips curated by specialists",
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-3">
                <FiCheckCircle className="text-blue-600 text-xl" />
                <p className="text-gray-700 font-medium">{item}</p>
              </div>
            ))}
          </div>

       

          {/* CTA BUTTONS */}
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <button className="bg-blue-600 text-white px-8 py-3 rounded-xl shadow-md text-lg font-semibold hover:bg-blue-500 transition-all flex items-center gap-2">
              Get Free Consultation <FiArrowRight className="text-xl" />
            </button>

            <button className="border border-blue-600 text-blue-600 px-8 py-3 rounded-xl shadow-md text-lg font-semibold hover:bg-blue-600 hover:text-white transition-all">
              Explore Services
            </button>
          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default TravelTipsSection;
